import React from 'react';
import { EcoSelectStation } from '@/comp';
import StationStages from '@/comp/StationStages/StationStages';
import * as S from './AIAssistantPage.styles';

const AssistantTopBar: React.FC = () => {
  return (
    <S.TopBar>
      <S.TopBarLeft>
        <S.StationPickerWrapper>
          <EcoSelectStation />
        </S.StationPickerWrapper>
      </S.TopBarLeft>
      <S.TopBarRight>
        <StationStages isTransparent={true} />
      </S.TopBarRight>
    </S.TopBar>
  );
};

AssistantTopBar.displayName = 'AssistantTopBar';

export default AssistantTopBar;
